import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import seven from "../../assets/images/user/7.jpg";
import { MyProfile,Password, EditProfile, Username,  UpdateProfile, EmailAddress, FirstName, LastName, Phone, ChangePassword, user_profile_title } from "../../constant";
import useCrud from "../../hooks/use_crud";
import LoadingSpinner from "../my-components/loading_spinner";
import ChangePasswordModal from "./change_password_modal";
import { emailValidator, notRequiredValidator, orValidators, passwordValidator, phoneValidator, requiredDropdownValidator, requiredValidator, showFormErrors, validateForm } from "../../utils/validators.js";
import { toast } from "react-toastify";

const UserEdit = () => {

  const [loading, setLoading] = useState(false)
  const {findById, edit} = useCrud({url : 'auth', setLoading : setLoading, firstLoad: false})
  const [data, setData] = useState({roles:[{name:"none"}]});
  const [updateData, setUpdateData] = useState({roles:[{name:"none"}]});
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false)

  useEffect(() => {
   
    findById(localStorage.getItem("userId")).then(user => {
      setData(user)
      setUpdateData({
        ...user,
        name: user.name? user.name.replace(user.familyName,'').trimEnd(): ''
      })
    })
    
  }, []);

  const validators = {
    email: emailValidator,
    username: requiredValidator('Nombre de usuario'),
    type: requiredDropdownValidator('Tipo de usuario'),
    roles: requiredDropdownValidator('Rol'),
    name: requiredValidator('Nombre'),
    familyName: requiredValidator('Apellidos'),
    cellphone: orValidators([phoneValidator,notRequiredValidator])
  }

  const onSubmit = async () => {
    
    const validationResult = validateForm(updateData, validators)
    if(validationResult.isValid){
      await edit({
        id:updateData.id,
        username: updateData.username,
        name: `${updateData.name} ${updateData.familyName}`,
        familyName: updateData.familyName,
        cellphone: updateData.cellphone,
        roles: updateData.roles
        })
        
        findById(localStorage.getItem("userId")).then(user => {
          setData(user)
        })
    }
    else
        showFormErrors(validationResult, toast)
  } 

  return (
    <Fragment>
      <br/>
      <div className="container-fluid">
        <div className="edit-profile">
          <Breadcrumb  title={user_profile_title}/>
          <div className="row">
            <div className="col-lg-4">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title mb-0">{MyProfile}</h4>
                  <div className="card-options">
                    <a className="card-options-collapse" href="javascript" data-toggle="card-collapse">
                      <i className="fe fe-chevron-up"></i>
                    </a>
                    <a className="card-options-remove" href="javascript" data-toggle="card-remove">
                      <i className="fe fe-x"></i>
                    </a>
                  </div>
                </div>
                <div className="card-body">
                  <form>
                    <div className="row mb-2">
                      <div className="col-auto">
                        <img className="img-70 rounded-circle" alt="" src={seven} />
                      </div>
                      <div className="col">
                        <h3 className="mb-1">{data.username}</h3>
                        <p className="mb-4">{data.roles[0].name}</p>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label">{EmailAddress+": "+ data.email}</label>
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label">{FirstName+": "+ data.name}</label>
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label">{Phone+": "+ data.cellphone}</label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <form className="card">
                <div className="card-header">
                  <h4 className="card-title mb-0">{EditProfile}</h4>
                  <div className="card-options">
                    <a className="card-options-collapse" href="javascript" data-toggle="card-collapse">
                      <i className="fe fe-chevron-up"></i>
                    </a>
                    <a className="card-options-remove" href="javascript" data-toggle="card-remove">
                      <i className="fe fe-x"></i>
                    </a>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6 col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-label">{Username}</label>
                        <input className="form-control" type="text" value={updateData.username} onChange={(evt)=> setUpdateData({...updateData,username:evt.target.value})} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-label">{FirstName}</label>
                        <input className="form-control" type="text" value={updateData.name} onChange={(evt)=> setUpdateData({...updateData,name:evt.target.value})} />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-label">{LastName}</label>
                        <input className="form-control" type="text" value={updateData.familyName} onChange={(evt)=> setUpdateData({...updateData,familyName:evt.target.value})} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-label">{Phone}</label>
                        <input className="form-control" type="text" value={updateData.cellphone} onChange={(evt)=> setUpdateData({...updateData,cellphone:evt.target.value})} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                <button className="btn btn-primary" type="button" onClick={()=>{setIsChangePasswordModalOpen(true)}}>
                    {ChangePassword}
                  </button>
                  <button className="btn btn-primary" type="button" onClick={onSubmit}>
                    {UpdateProfile}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingSpinner isVisible={loading} />
      <ChangePasswordModal isVisible={isChangePasswordModalOpen} onClose={()=>setIsChangePasswordModalOpen(false)}/>
    </Fragment>
  );
};

export default UserEdit;
